// @flow

import * as React from 'react';
import {useState} from 'react';
import Badge from 'sail/Badge';
import {Callout, Heading} from 'docs/components';
import {UnstyledLink} from 'sail/UnstyledLink';
import {useIntl, defineMessages, FormattedMessage} from 'react-intl';
import GLOSSARY from './glossary.yaml';
import {definitionMessages, termMessages} from './glossaryMessages';

const messages = defineMessages({
  glossaryIndexFilter: {
    id: 'docsShell.markdocContent.glossaryIndexFilter',
    description: 'Informs the user that the glossary list is filtered',
    defaultMessage: 'Filtering to show entries with the tag:',
  },
});

export const GlossaryIndex = () => {
  const intl = useIntl();
  const [selectedTag, setSelectedTag] = useState(null);

  const glossary = Object.entries(
    Object.entries(GLOSSARY)
      .filter(
        ([_, data]: [any, any]) =>
          !data.hidden && (!selectedTag || data.tags?.includes(selectedTag)),
      )
      .reduce((items, [id, data]: [string, any]) => {
        const letter = data.term[0].toUpperCase();
        (items[letter] = items[letter] ?? []).push({id, ...data});
        return items;
      }, {}),
  ).sort(([l1], [l2]) => l1.localeCompare(l2));

  const glossaryElements = glossary.map(([letter, entries]) => (
    <React.Fragment key={letter}>
      <Heading
        level={2}
        id={`glossary-letter-${letter.toLowerCase()}`}
        anchored
      >
        {letter}
      </Heading>
      {(entries: any).map((entry) => (
        <dl key={entry.id} className="info">
          <dt>
            <Heading level={3} id={`glossary-definition-${entry.id}`} anchored>
              {intl.formatMessage(termMessages[entry.id])}
            </Heading>
          </dt>
          <dd>
            <p>{intl.formatMessage(definitionMessages[entry.id])}</p>
            {entry.tags && (
              <p>
                {entry.tags.map((tag) => (
                  <UnstyledLink key={tag} onClick={(ev) => setSelectedTag(tag)}>
                    <Badge label={tag} />
                  </UnstyledLink>
                ))}
              </p>
            )}
          </dd>
        </dl>
      ))}
    </React.Fragment>
  ));

  return (
    <>
      {selectedTag && (
        <Callout type="note">
          <FormattedMessage {...messages.glossaryIndexFilter} />
          <UnstyledLink onClick={(ev) => setSelectedTag(null)}>
            <Badge icon="cancel" label={selectedTag} />
          </UnstyledLink>
        </Callout>
      )}
      {glossaryElements}
    </>
  );
};
